export const emissionItemCategories = {
	all: 'Alle',
	popular: 'Ofte brukt',
	others: 'Andre',
	addYourOwn: 'Legg til din egen',
	businessTravel: 'Tjenestereiser',
	transport: 'Transport',
	energyConsumption: 'Energiforbruk',
	consumerGoodsAndServices: 'Forbruksvarer og tjenester',
	informationAndCommunication: 'Informasjon og kommunikasjon',
	financeAndInsuranceServices: 'Finans- og forsikringstjenester',
	waste: 'Avfall',
	agricultureAquacultureAndForestry: 'Landbruk, akvakultur og skogbruk',
	realEstate: 'Eiendom',
	leasedAssetsRental: 'Leide eiendeler / Utleie',
	foodAndBeverage: 'Mat og drikke',
}
